<router-outlet />
<app-pwa-update></app-pwa-update>
<app-pwa-install></app-pwa-install>
